import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../styles/pp-auth.css';
import LogoMark from './LogoMark';
import { RemoteIcon, PromoIcon, PulseIcon } from './icons';

export const WHATSAPP = '+966 58 327 2051';
export const SUPPORT_EMAIL = 'info@ubitc.com';

/**
 * Split-pane layout shared by every customer auth page: an always-dark brand
 * panel (animated logo) beside the form pane, which follows the app theme
 * (html[data-theme] from pp_theme, else prefers-color-scheme). On phones the
 * panel collapses to a slim header. See pp-auth.css.
 */
export default function AuthShell({ children }) {
  const { t, i18n } = useTranslation();
  const lang = (i18n.resolvedLanguage || i18n.language || 'en').startsWith('ar') ? 'ar' : 'en';
  const setLang = (lng) => { if (lng !== lang) i18n.changeLanguage(lng); };
  const a = (k) => t(`authPage.${k}`);

  return (
    <div className="ppa">
      <div className="ppa-auth">
        <aside className="ppa-brand" aria-label="PopupPush">
          <div className="ppa-brand-top">
            <LogoMark size={56} />
            <span className="ppa-word">Popup<b>Push</b></span>
          </div>
          <div className="ppa-brand-mid">
            <h2>{a('brandA')} <span>{a('brandB')}</span></h2>
            <p>{a('brandP')}</p>
            <ul className="ppa-points">
              <li><i><RemoteIcon /></i><span>{a('pt1')}</span></li>
              <li><i><PromoIcon /></i><span>{a('pt2')}</span></li>
              <li><i><PulseIcon /></i><span>{a('pt3')}</span></li>
            </ul>
            <div className="ppa-screens">
              {[1, 2, 3, 4].map((n) => (<span className="ppa-scr" key={n}><s />{a(`scr${n}`)}</span>))}
            </div>
          </div>
          <div className="ppa-brand-foot"><span dir="ltr">popuppush.com</span><span>{a('bcopy')}</span></div>
        </aside>

        <main className="ppa-pane">
          <div className="ppa-pane-top">
            <div className="ppa-lang" role="group" aria-label={a('langLabel')}>
              <button type="button" lang="ar" aria-pressed={lang === 'ar'} onClick={() => setLang('ar')}>ع</button>
              <button type="button" lang="en" aria-pressed={lang === 'en'} onClick={() => setLang('en')}>EN</button>
            </div>
          </div>
          <div className="ppa-stage"><div className="ppa-card" aria-live="polite">{children}</div></div>
          <div className="ppa-foot">
            <span>{a('foot')} <span className="ppa-num">{WHATSAPP}</span></span>
            <span dir="ltr">{SUPPORT_EMAIL}</span>
          </div>
        </main>
      </div>
    </div>
  );
}
